export interface Invoice {
  id: string
  supplierId: string
  supplierName: string
  poId?: string
  status:
    | 'draft'
    | 'submitted'
    | 'under-review'
    | 'approved'
    | 'matched'
    | 'payment-scheduled'
    | 'paid'
    | 'rejected'
    | 'exception'
    | 'credit-note'
  invoiceDate: string
  dueDate: string
  totalAmount: number
  currency: string
  lineItems: number
  matchStatus: 'full-match' | 'partial-match' | 'no-match' | 'pending' | 'n/a'
  exceptionType?: string
  paymentRef?: string
  submittedDate?: string
  approvedDate?: string
  paidDate?: string
}

export const invoices: Invoice[] = [
  {
    id: 'INV-2026-00089',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    poId: 'PO-2026-00132',
    status: 'approved',
    invoiceDate: '2026-03-09',
    dueDate: '2026-04-08',
    totalAmount: 38700,
    currency: 'SGD',
    lineItems: 5,
    matchStatus: 'full-match',
    submittedDate: '2026-03-09',
    approvedDate: '2026-03-12',
  },
  {
    id: 'INV-2026-00095',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    poId: 'PO-2026-00140',
    status: 'exception',
    invoiceDate: '2026-03-14',
    dueDate: '2026-04-13',
    totalAmount: 12500,
    currency: 'SGD',
    lineItems: 3,
    matchStatus: 'partial-match',
    exceptionType: 'Quantity variance on line item 2',
    submittedDate: '2026-03-14',
  },
  {
    id: 'INV-2026-00096',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    poId: 'PO-2026-00141',
    status: 'submitted',
    invoiceDate: '2026-03-15',
    dueDate: '2026-04-14',
    totalAmount: 45200,
    currency: 'SGD',
    lineItems: 8,
    matchStatus: 'pending',
    submittedDate: '2026-03-15',
  },
  {
    id: 'INV-2026-00075',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    poId: 'PO-2026-00115',
    status: 'paid',
    invoiceDate: '2026-02-10',
    dueDate: '2026-03-12',
    totalAmount: 89000,
    currency: 'SGD',
    lineItems: 12,
    matchStatus: 'full-match',
    submittedDate: '2026-02-10',
    approvedDate: '2026-02-14',
    paidDate: '2026-03-10',
    paymentRef: 'PAY-2026-0310-005',
  },
  {
    id: 'INV-2026-00080',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    poId: 'PO-2026-00120',
    status: 'payment-scheduled',
    invoiceDate: '2026-02-25',
    dueDate: '2026-03-27',
    totalAmount: 56400,
    currency: 'SGD',
    lineItems: 6,
    matchStatus: 'full-match',
    submittedDate: '2026-02-25',
    approvedDate: '2026-02-28',
    paymentRef: 'PAY-2026-03-27-BATCH',
  },
  {
    id: 'INV-2026-00088',
    supplierId: 'SUP-002',
    supplierName: 'Golden Fields Agriculture',
    poId: 'PO-2026-00130',
    status: 'payment-scheduled',
    invoiceDate: '2026-03-05',
    dueDate: '2026-04-19',
    totalAmount: 112400,
    currency: 'SGD',
    lineItems: 10,
    matchStatus: 'full-match',
    submittedDate: '2026-03-05',
    approvedDate: '2026-03-08',
    paymentRef: 'PAY-2026-04-19-BATCH',
  },
  {
    id: 'INV-2026-00087',
    supplierId: 'SUP-003',
    supplierName: 'Pacific Meats International',
    poId: 'PO-2026-00128',
    status: 'paid',
    invoiceDate: '2026-02-28',
    dueDate: '2026-03-30',
    totalAmount: 298500,
    currency: 'SGD',
    lineItems: 8,
    matchStatus: 'full-match',
    submittedDate: '2026-02-28',
    approvedDate: '2026-03-03',
    paidDate: '2026-03-14',
    paymentRef: 'PAY-2026-0314-001',
  },
  {
    id: 'INV-2026-00086',
    supplierId: 'SUP-004',
    supplierName: 'NutriPack Solutions',
    poId: 'PO-2026-00127',
    status: 'exception',
    invoiceDate: '2026-03-01',
    dueDate: '2026-04-30',
    totalAmount: 72100,
    currency: 'SGD',
    lineItems: 15,
    matchStatus: 'partial-match',
    exceptionType: 'Price variance on 2 line items',
    submittedDate: '2026-03-01',
  },
  {
    id: 'INV-2026-00085',
    supplierId: 'SUP-005',
    supplierName: 'Evergreen Label Manufacturing',
    poId: 'PO-2026-00125',
    status: 'under-review',
    invoiceDate: '2026-03-10',
    dueDate: '2026-04-24',
    totalAmount: 176000,
    currency: 'SGD',
    lineItems: 18,
    matchStatus: 'pending',
    submittedDate: '2026-03-10',
  },
  {
    id: 'INV-2026-00084',
    supplierId: 'SUP-006',
    supplierName: 'MedWell Pharma Distribution',
    poId: 'PO-2026-00137',
    status: 'submitted',
    invoiceDate: '2026-03-15',
    dueDate: '2026-04-14',
    totalAmount: 189200,
    currency: 'SGD',
    lineItems: 20,
    matchStatus: 'pending',
    submittedDate: '2026-03-15',
  },
  {
    id: 'INV-2026-00083',
    supplierId: 'SUP-012',
    supplierName: 'Sunrise Dairy Co-op',
    poId: 'PO-2026-00124',
    status: 'paid',
    invoiceDate: '2026-02-20',
    dueDate: '2026-04-05',
    totalAmount: 143200,
    currency: 'SGD',
    lineItems: 9,
    matchStatus: 'full-match',
    submittedDate: '2026-02-20',
    approvedDate: '2026-02-24',
    paidDate: '2026-03-10',
    paymentRef: 'PAY-2026-0310-003',
  },
  {
    id: 'INV-2026-00082',
    supplierId: 'SUP-013',
    supplierName: 'Bintang Raya Foods',
    poId: 'PO-2026-00122',
    status: 'rejected',
    invoiceDate: '2026-02-25',
    dueDate: '2026-04-25',
    totalAmount: 88900,
    currency: 'SGD',
    lineItems: 16,
    matchStatus: 'no-match',
    exceptionType: 'PO reference mismatch',
    submittedDate: '2026-02-25',
  },
  {
    id: 'INV-2026-00081',
    supplierId: 'SUP-011',
    supplierName: 'CleanPro Services',
    status: 'draft',
    invoiceDate: '2026-03-15',
    dueDate: '2026-04-14',
    totalAmount: 24800,
    currency: 'SGD',
    lineItems: 3,
    matchStatus: 'n/a',
  },
  {
    id: 'INV-2026-00080',
    supplierId: 'SUP-008',
    supplierName: 'SwiftHaul Logistics',
    poId: 'PO-2026-00136',
    status: 'approved',
    invoiceDate: '2026-03-11',
    dueDate: '2026-04-10',
    totalAmount: 18500,
    currency: 'SGD',
    lineItems: 1,
    matchStatus: 'full-match',
    submittedDate: '2026-03-11',
    approvedDate: '2026-03-13',
  },
  {
    id: 'CN-2026-00005',
    supplierId: 'SUP-004',
    supplierName: 'NutriPack Solutions',
    poId: 'PO-2026-00120',
    status: 'credit-note',
    invoiceDate: '2026-03-08',
    dueDate: '2026-03-08',
    totalAmount: -4500,
    currency: 'SGD',
    lineItems: 2,
    matchStatus: 'full-match',
    submittedDate: '2026-03-08',
    approvedDate: '2026-03-10',
  },
]

export function getInvoicesBySupplier(supplierId: string): Invoice[] {
  return invoices.filter((inv) => inv.supplierId === supplierId)
}

export function getInvoiceById(id: string): Invoice | undefined {
  return invoices.find((inv) => inv.id === id)
}
